// extracted by mini-css-extract-plugin
module.exports = {"seller-modal":"SellerModal_seller-modal__mLOea"};